export default "__VITE_ASSET__BUwLC87K__"